module.exports = __webpack_public_path__ + "img/108.d6f56642.jpg";